module.exports = __webpack_public_path__ + "static/media/icon_arrow_left_red.5e43fcec.svg";